import { MICRO_TRANSITION_TIMING } from 'HubStyleTokens/times';
import { RightIcon } from 'foundations-assets';
import styled from 'styled-components';

// Copied from https://git.hubteam.com/HubSpot/foundations-components/blob/master/foundations-components/static-1.5100/js/transitional/components/ExpandableSection/ExpandableSection.tsx#L159-L159
// Only updated size
import { jsx as _jsx } from "react/jsx-runtime";
const StyledCaretWrapper = styled.div.withConfig({
  displayName: "ExpandableCaret__StyledCaretWrapper",
  componentId: "sc-19hcwiv-0"
})(({
  open
}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexBasis: '16px',
  flexShrink: 0,
  transition: `all ${MICRO_TRANSITION_TIMING} ease-in-out`,
  transform: open ? 'rotate(90deg)' : undefined
}));
export const ExpandableCaret = ({
  open
}) => {
  return /*#__PURE__*/_jsx(StyledCaretWrapper, {
    open: open,
    children: /*#__PURE__*/_jsx(RightIcon, {
      color: "text-interactive-default",
      size: '100'
    })
  });
};